const MEMBER_WALLET_REPLENISH_REQUEST = 'MEMBER_WALLET_REPLENISH_REQUEST';
const MEMBER_WALLET_REPLENISH_SUCCESS = 'MEMBER_WALLET_REPLENISH_SUCCESS';
const MEMBER_WALLET_REPLENISH_ERROR = 'MEMBER_WALLET_REPLENISH_ERROR';

const initState = {
    virtualGift: null
};

import * as backend from 'backend-helpers/memberWalletReplenish';

export default function memberWalletReplenish(state = initState, action) {
    if (action.type === MEMBER_WALLET_REPLENISH_SUCCESS) {
        let {virtualGift} = action.result;

        return {
            virtualGift
        }
    }

    return state;
}

export function getMemberWalletReplenish(giftId) {
    return {
        types: [MEMBER_WALLET_REPLENISH_REQUEST, MEMBER_WALLET_REPLENISH_SUCCESS, MEMBER_WALLET_REPLENISH_ERROR],
        promise: backend.getMemberWalletReplenish({giftId})
    }
}


// WEBPACK FOOTER //
// ./src/reducers/memberWalletReplenish.js